export default __webpack_public_path__ + "static/media/MuseoSans_500-webfont.4c6110fb.eot";